import { InjectionToken } from "@angular/core";

export const COMPONENT_MAP = new InjectionToken("component map");
